import React, { useEffect, useState, createElement } from 'react';
import { ArrowRight, Play, ChevronDown, ChevronUp, Star } from 'lucide-react';
import { Button } from './ui/Button';
import { Container } from './ui/Container';
import { ImageCarousel } from './ImageCarousel';
import { VideoModal } from './VideoModal';
import { QualityBadges } from './QualityBadges';
export function HeroSection() {
  const [isVideoOpen, setIsVideoOpen] = useState(false);
  const [isCalendlyOpen, setIsCalendlyOpen] = useState(false);
  const brandLogos = [{
    src: 'https://cdn.magicpatterns.com/uploads/k26YNKXCkRHHrYsHicyBcX/acciom_icon.jpg',
    alt: 'Acciom'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/3PvttSuV36HJYTb8saM4zH/djsl_icon.jpg',
    alt: 'DJSL'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/6FkLsF3EkZNNMwuaZgnowe/nigeriatax_icon.jpg',
    alt: 'Nigeria Tax'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/dcDXz6L5yZD6qGiqvwWMTv/quickblog_icon.jpg',
    alt: 'QuickBlog'
  }];
  // Load Calendly script when component mounts
  useEffect(() => {
    if (isCalendlyOpen && !document.querySelector('script[src*="calendly"]')) {
      const script = document.createElement('script');
      script.src = 'https://assets.calendly.com/assets/external/widget.js';
      script.async = true;
      document.body.appendChild(script);
    }
  }, [isCalendlyOpen]);
  return <>
      <div className="relative overflow-hidden bg-white pt-16 pb-32 lg:pt-24 lg:pb-40" data-id="element-45">
        <Container data-id="element-46">
          <div className="lg:grid lg:grid-cols-12 lg:gap-8" data-id="element-47">
            <div className="sm:text-center md:mx-auto md:max-w-2xl lg:col-span-6 lg:text-left" data-id="element-48">
              {/* Quality Badges */}
              <QualityBadges data-id="element-49" />

              <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl md:text-6xl" data-id="element-50">
                Turn Your Klaviyo Flows Into{' '}
                <span className="gradient-text block" data-id="element-51">Revenue Machines</span>
              </h1>
              <p className="mt-6 text-base text-gray-500 sm:text-lg md:mt-10 md:text-xl" data-id="element-52">
                AI-powered flow optimization that finds hidden opportunities,
                fixes performance issues, and proves ROI—automatically.
              </p>
              <div className="mt-8 sm:mx-auto sm:max-w-lg md:mt-10 lg:mx-0" data-id="element-53">
                {/* Stars */}
                <div className="text-center mb-4" data-id="element-54">
                  <div className="flex items-center justify-center py-6 gap-1" data-id="element-55">
                    {[...Array(5)].map((_, i) => <Star key={i} className="h-6 w-6 text-yellow-400 fill-yellow-400" data-id="element-56" />)}
                  </div>
                </div>

                {/* CTA Buttons Row */}
                <div className="flex flex-col sm:flex-row gap-3" data-id="element-57">
                  <div className="flex-1 rounded-md shadow" data-id="element-58">
                    <a href="https://go.useflowsense.com/signup" data-id="element-59">
                      <Button size="lg" className="w-full" rightIcon={<ArrowRight className="h-5 w-5" data-id="element-61" />} data-id="element-60">
                        Signup Free
                      </Button>
                    </a>
                  </div>
                  <div className="flex-1" data-id="element-62">
                    <Button variant="outline" size="lg" className="w-full" leftIcon={<Play className="h-5 w-5" data-id="element-64" />} onClick={() => setIsVideoOpen(true)} data-id="element-63">
                      See How It Works
                    </Button>
                  </div>
                </div>

                {/* Book A Demo Button - Full Width */}
                <div className="mt-3" data-id="element-65">
                  <button onClick={() => setIsCalendlyOpen(!isCalendlyOpen)} className="w-full inline-flex items-center justify-center px-8 h-12 text-base font-medium rounded-md bg-black text-white hover:bg-white hover:text-black border-2 border-black transition-all duration-200" data-id="element-66">
                    {isCalendlyOpen ? <>
                        Collapse Booking Form
                        <ChevronUp className="ml-2 h-5 w-5" data-id="element-67" />
                      </> : <>
                        Book A Demo
                        <ChevronDown className="ml-2 h-5 w-5" data-id="element-68" />
                      </>}
                  </button>
                </div>

                {/* Calendly Embed - Expandable (Right Below Button) */}
                <div className={`transition-all duration-500 ease-in-out overflow-hidden ${isCalendlyOpen ? 'max-h-[800px] opacity-100 mt-4' : 'max-h-0 opacity-0'}`} data-id="element-69">
                  <div className="bg-white rounded-lg border-2 border-gray-200 shadow-xl" data-id="element-70">
                    {/* Calendly inline widget begin */}
                    <div className="calendly-inline-widget" data-url="https://calendly.com/hello-useflowsense/30min?hide_event_type_details=1&hide_gdpr_banner=1&primary_color=1a1a1a" style={{
                    minWidth: '320px',
                    height: '700px'
                  }} data-id="element-71"></div>
                    {/* Calendly inline widget end */}
                  </div>
                </div>
              </div>

              <div className="mt-8 border-t border-gray-200 pt-8 md:flex md:items-center md:justify-center lg:justify-start" data-id="element-72">
                <div className="flex items-center space-x-5" data-id="element-73">
                  <div className="flex -space-x-2 overflow-hidden" data-id="element-74">
                    {brandLogos.map((logo, i) => <img key={i} className="inline-block h-8 w-8 rounded-full ring-2 ring-white object-cover" src={logo.src} alt={logo.alt} data-id="element-75" />)}
                  </div>
                  <div className="text-sm font-medium text-gray-500" data-id="element-76">
                    Trusted by{' '}
                    <span className="font-bold text-gray-900" data-id="element-77">
                      multiple online brands
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="relative mt-12 sm:mx-auto sm:max-w-lg lg:col-span-6 lg:mx-0 lg:mt-0 lg:flex lg:max-w-none lg:items-center" data-id="element-78">
              <ImageCarousel data-id="element-79" />
            </div>
          </div>
        </Container>

        <style data-id="element-80">{`
          @keyframes gradientShift {
            0% {
              background-position: 0% 50%;
            }
            50% {
              background-position: 100% 50%;
            }
            100% {
              background-position: 0% 50%;
            }
          }
          
          .gradient-text {
            background: linear-gradient(90deg, #6366F1, #8B5CF6, #10B981, #3B82F6, #6366F1);
            background-size: 200% auto;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            animation: gradientShift 8s ease infinite;
          }
        `}</style>
      </div>

      <VideoModal isOpen={isVideoOpen} onClose={() => setIsVideoOpen(false)} data-id="element-81" />
    </>;
}